const GetCazaHistoryAdmin = async (idCaza: string, idUsuari: string, idConjunt?: number | null) => {
    try {
        const conjuntParam = idConjunt != null ? `?idConjunt=${idConjunt}` : '';
        const response = await fetch(`${process.env.REACT_APP_API_URL}:8061/jutge/caza/${idCaza}/admin/alumnos/${idUsuari}/history${conjuntParam}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        const data = await response.json();
        if (Array.isArray(data)) {
            return data;
        } else {
            console.error("Received non-array history data:", data);
            return [];
        }
    } catch (error) {
        console.error('Error fetching history:', error);
        return [];
    }
}

export { GetCazaHistoryAdmin };
